<template>
	<div class="bright container-fluid py-4">
		<div class="row">
			<div class="col-md-6">
				<BarCard title="SERVICE LEVEL SUPPLIER CASE FILL (%)" :data="weekly.slscase" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="SERVICE LEVEL SUPPLIER LINE FILL (%)" :data="weekly.slsline" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="SERVICE LEVEL SUPPLIER PER DC CASE FILL (%)" :data="weekly.slsdcase" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="SERVICE LEVEL SUPPLIER PER DC LINE FILL (%)" :data="weekly.slsdline" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="SERVICE LEVEL DC CASE FILL (%)" :data="weekly.sldcase" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="SERVICE LEVEL DC LINE FILL (%)" :data="weekly.sldline" :width="500" :height="280"/>
			</div>
		</div>
	</div>
</template>

<script>
import Bright from '@/components/page/Bright.js'
import BarCard from '@/views/pages/BarCard.vue'

export default{
	extends: Bright,
	components:{
		BarCard,
    },
    mounted(){
		this.$emit('childrenRoute')
		this.loadWeekly();
    },
    methods:{
    },
}
</script>
<style>
.home.row1,.home.row2{ height: 300px;}
.text-merah{ color:#c7251c }
.text-biru{ color:#066fb1   }
.text-hijau{ color:#acc437  }
</style>